"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Sidebar;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = require("./context");

var _nav = _interopRequireDefault(require("./styled/nav"));

var _ul = _interopRequireDefault(require("./styled/ul"));

/**
 * The Sidebar component is a vertical bar that holds a list of SidebarItems.
 * It helps users to jump from one site section to another without re-rendering the entire content on the page.
 * Note that you have to compose the Sidebar with the SidebarItem component.
 * @category Layout
 */
function Sidebar(props) {
  var ariaLabel = props.ariaLabel,
      style = props.style,
      selectedItem = props.selectedItem,
      onSelect = props.onSelect,
      className = props.className,
      children = props.children,
      id = props.id,
      hideSelectedItemIndicator = props.hideSelectedItemIndicator;
  var context = {
    selectedItem: selectedItem,
    onSelect: onSelect,
    hideSelectedItemIndicator: hideSelectedItemIndicator
  };
  return /*#__PURE__*/_react["default"].createElement(_nav["default"], {
    id: id,
    className: className,
    style: style,
    "aria-label": ariaLabel
  }, /*#__PURE__*/_react["default"].createElement(_context.Provider, {
    value: context
  }, /*#__PURE__*/_react["default"].createElement(_ul["default"], null, children)));
}

Sidebar.propTypes = {
  /** The id of the outer element. */
  id: _propTypes["default"].string,

  /** Name of the nagivation item to make active. */
  selectedItem: _propTypes["default"].string,

  /** Action fired when an item is selected.
   * The event params include the `name` of the selected item. */
  onSelect: _propTypes["default"].func,

  /** The aria label attribute for the navigation component. */
  ariaLabel: _propTypes["default"].string,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied for the outer element. */
  style: _propTypes["default"].object,

  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes["default"].node,

  /** Controls if the selected item indicator should be hidden. */
  hideSelectedItemIndicator: _propTypes["default"].bool
};
Sidebar.defaultProps = {
  selectedItem: null,
  onSelect: function onSelect() {},
  ariaLabel: undefined,
  className: undefined,
  style: undefined,
  children: null,
  id: undefined,
  hideSelectedItemIndicator: false
};